import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useHistoryStore } from '../../../hooks/useObjectHistory';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const HistoryStoreWidget = (props) => {
    const { controls } = useHistoryStore({
        contextObject: props.user ?? {},
        historyStoreKey: 'recentStateHistory',
        historyStoreFilter: {},
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "useHistoryStore" }), _jsx(Typography, { variant: "h5", children: "period" }), _jsx(Stack, { direction: "row", children: controls.filterWidgetComponents.period }), _jsx(Typography, { variant: "h5", children: "readings" }), _jsx(Stack, { direction: "row", children: controls.filterWidgetComponents.readings }), _jsx(Typography, { variant: "h5", children: "sample" }), _jsx(Stack, { direction: "row", children: controls.filterWidgetComponents.sample }), _jsx(Typography, { variant: "h5", children: "deleteControl" }), _jsx(Stack, { direction: "row", children: controls.deleteControl }), _jsx(Typography, { variant: "h5", children: "TimePeriodSelector" }), _jsx(Stack, { direction: "row", children: controls.timeSelectorComponents.TimePeriodSelector })] })), [controls]);
    return {
        name: 'useObjectHistory',
        category: 'hooks',
        component,
    };
};
